import {
  ON_GET_AUTH_BOOKINGS,
  // GET_AUTH_THIS_MONTH_BOOKING,
  // GET_AUTH_BOOKING_ERROR,
  ON_GET_CUSTOMER_QUOTATIONS,
  GET_CUSTOMER_QUOTATIONS,
  CUSTOMER_QUOTATIONS_ERROR,

  GET_AUTH_THIS_MONTH_BOOKING,
  GET_AUTH_CURRENT_BOOKING,
  GET_AUTH_UPCOMING_BOOKING,
  GET_AUTH_PREVIOUS_BOOKING,
  GET_AUTH_CANCELLED_BOOKING,
  GET_AUTH_DETAIL_BOOKING,
  GET_AUTH_BOOKING_ERROR,
} from "../types";
import customAxios from "../../utils/customAxios";
import setAuthToken from "../../utils/setAuthToken";

/**
* * Get all bookings using the filters
*/
export const newGetBookings = ({
  orderBy = "date",
  sortBy = "desc",
  search = "",
  page = 1,
  limit = 10,
  id = "",
}, typeBooking) => async (dispatch) => {
  try {
    dispatch({
      type: ON_GET_AUTH_BOOKINGS,
    });

    let params = {
      orderBy,
      sortBy,
      search,
      page,
      limit,
      isAbandoned: false
    };
    let reducerTag = GET_AUTH_THIS_MONTH_BOOKING;

    const now = new Date();

    switch (typeBooking) {
      case "thisMonth":
        params.startDate = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0)
        params.endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999)
        params.bookingStatus = "CONFIRMED,CANCELLED"

        reducerTag = GET_AUTH_THIS_MONTH_BOOKING;

        break;
      case "current":
        params.startDate = new Date();
        params.bookingStatus = "CONFIRMED"

        reducerTag = GET_AUTH_CURRENT_BOOKING;

        break;
      case "upcoming":
        params.startDate = new Date();
        params.bookingStatus = "CONFIRMED"

        reducerTag = GET_AUTH_UPCOMING_BOOKING;

        break;
      case "previous":
        params.endDate = new Date();
        params.bookingStatus = "CONFIRMED"

        reducerTag = GET_AUTH_PREVIOUS_BOOKING;

        break;
      case "cancelled":
        params.bookingStatus = "CANCELLED"

        reducerTag = GET_AUTH_CANCELLED_BOOKING;

        break;

      case "detail":
        params.id = id

        reducerTag = GET_AUTH_DETAIL_BOOKING;

        break;
      default:
        break;
    }

    const queryString = new URLSearchParams(params).toString();

    const res = await customAxios.get(
      `/api/auth/bookings?${queryString}`
    );

    dispatch({
      type: reducerTag,
      payload: reducerTag === GET_AUTH_DETAIL_BOOKING ? res.data.data.data[0] : res.data.data
    });

  } catch (err) {
    dispatch({
      type: GET_AUTH_BOOKING_ERROR,
      payload: err?.response?.data
    })
  }
};

/**
* * Get all bookings using the filters
*/
export const newGetQuotations = (params) =>
  async (dispatch) => {
    try {
      dispatch({
        type: ON_GET_CUSTOMER_QUOTATIONS,
      });

      const queryString = new URLSearchParams(params).toString();

      const res = await customAxios.get(
        `/api/admin/quotations?${queryString}`
      );

      dispatch({
        type: GET_CUSTOMER_QUOTATIONS,
        payload: res.data.data,
      });
    } catch (err) {
      dispatch({
        type: CUSTOMER_QUOTATIONS_ERROR,
        payload: {
          msg: err.response?.statusText,
          status: err.response?.status,
        },
      });
    }
  };